export enum LinkStyle {
    Primary = 'primary',
    DarkAccordionHeader = 'dark-accordion-header',
}
